import { createContext } from 'react';

const RouteContext = createContext<[string, (currentPath: string) => void]>(['/', () => { }]);

export default RouteContext;